import React from 'react';
import CreativeTwoColumn from './components/CreativeTwoColumn';
import ProfessionalClean from './components/templates/ProfessionalClean';
import ElegantSerif from './components/templates/ElegantSerif';
import CompactTech from './components/templates/CompactTech';
import BorderedAcademic from './components/templates/BorderedAcademic';
import Compact from './components/templates/Compact';

/**
 * Map a template key to a component. Includes legacy aliases so existing
 * resumes (saved before the template rebuild) keep rendering correctly.
 */
const TEMPLATE_REGISTRY = {
  // Current canonical keys (TemplateSelector uses these)
  'modern':              ProfessionalClean,
  'executive':           ElegantSerif,
  'tech':                CompactTech,
  'academic':            BorderedAcademic,
  'creative':            CreativeTwoColumn,
  'compact':             Compact,
  // Older keys still in saved resumes — alias to the new templates
  'professional-clean':  ProfessionalClean,
  'elegant-serif':       ElegantSerif,
  'compact-tech':        CompactTech,
  'bordered-academic':   BorderedAcademic,
  'creative-two-column': CreativeTwoColumn,
  'classic':             ElegantSerif,  // legacy "classic" → executive serif
  'minimal':             Compact,        // legacy "minimal" → compact
  'modern2':             ProfessionalClean
};

const resolveTemplate = (key) => TEMPLATE_REGISTRY[key] || ProfessionalClean;

const ResumePreview = React.forwardRef(({ data, template }, ref) => {
  const Template = resolveTemplate(template);
  return (
    <div
      ref={ref}
      className="w-full max-w-full overflow-x-auto bg-gray-50 print:bg-white"
      style={{
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact'
      }}
    >
      <Template data={data} />
    </div>
  );
});

ResumePreview.displayName = 'ResumePreview';

/**
 * A read-only grid of every template rendered with the same data — used
 * elsewhere in the app for "preview all" pages. Kept here so callers don't
 * need to know the template registry.
 */
export const TemplatePreviewGrid = ({ data }) => {
  const templates = [
    { name: 'Modern',    Component: ProfessionalClean },
    { name: 'Executive', Component: ElegantSerif },
    { name: 'Tech',      Component: CompactTech },
    { name: 'Academic',  Component: BorderedAcademic },
    { name: 'Creative',  Component: CreativeTwoColumn },
    { name: 'Compact',   Component: Compact }
  ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 p-4">
      {templates.map(({ name, Component }) => (
        <div
          key={name}
          className="border rounded-lg shadow-sm p-4 bg-white hover:shadow-md transition duration-200 overflow-x-auto"
        >
          <div className="text-center font-semibold mb-2">{name}</div>
          <div className="text-sm">
            <Component data={data} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResumePreview;
